import type { Namespace } from '../types';

// DE drafted — queued for native review in the task file's "DE review queue".
// Shared terms (email, roles, user type, admin/member, …) live in `common`.
export const registration = {
  // ⚠ Headquarters is the WIDEST scope, not an unset field: no grants means
  // every site (D-061). The hint says so plainly, or an admin reads the
  // default as "nothing granted yet" when it is the opposite.
  worksAt: { de: 'Arbeitet bei', en: 'Works at' },
  scopeHq: { de: 'Hauptverwaltung', en: 'Headquarters' },
  scopeSite: { de: 'Ein Standort', en: 'A site' },
  hqHint: {
    de: 'Sieht ALLE Standorte. Für Unternehmensrollen.',
    en: 'Sees every site. For enterprise-wide roles.',
  },
  siteHint: {
    de: 'Diese Person arbeitet an genau einem Standort und sieht nur diesen.',
    en: 'This person works at exactly one site and sees only that one.',
  },
  selectSite: { de: 'Standort suchen…', en: 'Search for a site…' },
  siteRequired: { de: 'Wählen Sie den Standort.', en: 'Pick the site.' },
  sitesLoadError: {
    de: 'Standorte konnten nicht geladen werden.',
    en: 'Could not load the site list.',
  },

  title: { de: 'Registrierung', en: 'Registration' },
  desc: {
    de: 'Teammitglieder einladen und offene Beitritte verfolgen — Zeile anklicken für Link & Details',
    en: "Invite teammates and track who hasn't joined yet — click a row for the link & details",
  },
  inviteUser: { de: 'Benutzer einladen', en: 'Invite User' },

  statPending: { de: 'Ausstehende Einladungen', en: 'Pending invitations' },
  statExpiring: { de: 'Läuft in 24h ab', en: 'Expiring within 24h' },
  statExpired: { de: 'Abgelaufen', en: 'Expired' },

  colInvitedAs: { de: 'Eingeladen als', en: 'Invited as' },
  colSentBy: { de: 'Gesendet von', en: 'Sent by' },
  colSent: { de: 'Gesendet', en: 'Sent' },
  colExpires: { de: 'Läuft ab', en: 'Expires' },
  colStatus: { de: 'Status', en: 'Status' },
  badgeExpired: { de: 'Abgelaufen', en: 'Expired' },
  badgePending: { de: 'Ausstehend', en: 'Pending' },

  expiredOn: { de: 'Abgelaufen am {date}', en: 'Expired {date}' },
  inHours_one: { de: 'in {n} Stunde', en: 'in {n} hour' },
  inHours_many: { de: 'in {n} Stunden', en: 'in {n} hours' },
  inDays_many: { de: 'in {n} Tagen', en: 'in {n} days' },

  eyebrow: { de: 'Einladung', en: 'Invitation' },
  invitedBy: { de: 'Eingeladen von', en: 'Invited by' },
  inviteLink: { de: 'Einladungslink', en: 'Invitation link' },
  reinvite: { de: 'Erneut einladen', en: 'Re-invite' },
  resend: { de: 'Einladung erneut senden', en: 'Resend invitation' },
  copyLink: { de: 'Link kopieren', en: 'Copy link' },
  revoke: { de: 'Widerrufen', en: 'Revoke' },

  revokeTitle: { de: 'Einladung widerrufen?', en: 'Revoke invitation?' },
  revokeMsgPrefix: { de: 'Die Einladung an', en: 'The invitation to' },
  revokeMsgSuffix: { de: 'wird sofort ungültig.', en: 'will stop working immediately.' },

  toastLinkCopied: { de: 'Link kopiert', en: 'Link copied' },
  toastResent: { de: 'Einladung erneut gesendet an {email}', en: 'Invitation resent to {email}' },
  toastRevoked: { de: 'Einladung widerrufen', en: 'Invitation revoked' },
  toastSent: { de: 'Einladung gesendet an {email}', en: 'Invitation sent to {email}' },

  loadError: { de: 'Einladungen konnten nicht geladen werden', en: "Couldn't load invitations" },
  emptyTitle: { de: 'Noch keine Einladungen', en: 'No invitations yet' },
  emptyMsg: { de: 'Laden Sie ein Teammitglied ein, um zu starten.', en: 'Invite a teammate to get started.' },

  modalTitle: { de: 'Benutzer einladen', en: 'Invite user' },
  sendInvitation: { de: 'Einladung senden', en: 'Send invitation' },
  detailsTitle: { de: 'Einladungsdetails', en: 'Invitation details' },
  phEmail: { de: 'z. B. teammate@xantory.com', en: 'e.g. teammate@xantory.com' },
  rolesHint: { de: 'Eine oder mehrere Rollen wählen.', en: 'Pick one or more roles.' },
  filterType: { de: 'Alle Typen', en: 'All types' },
  filterStatus: { de: 'Alle Status', en: 'All statuses' },
  noInvitesMatch: {
    de: 'Keine Einladungen passen zu diesen Filtern',
    en: 'No invitations match these filters',
  },
  loadMore: { de: 'Mehr laden', en: 'Load more' },
  loadedCount: { de: '{shown} von {total} Einladungen geladen', en: '{shown} of {total} invitations loaded' },
} as const satisfies Namespace;
